<!--
 * @Author: your name
 * @Date: 2022-01-25 14:25:20
 * @LastEditTime: 2022-03-11 17:38:12
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \web-pc\src\views\thirdLogin.vue
-->

<template>
    <div></div>
</template>
<script>
    /*   import x2js from 'x2js'*/
    import { axios, thirdLogin, getPermissions } from "../plugin/axios";
    import userApi from "@/api/home.js";
    import Cookie from "js-cookie";
    export default {
        methods: {
            enableUrlAuth() {
                //判断是否已经登录 登录过直接到首页

                //var webUrl = "";

                //userApi
                //    .getCopyright()
                //    .then(res => {
                //        res.data.forEach(item => {
                //            if (item.name == 'Abp.Identity.User.WebUrl') {
                //                this.webUrl = item.value;
                //            }
                //        });
                //    })
                //    .catch(err => {
                //        console.warn(err);
                //    });

                if (sessionStorage.getItem('token')) {
                    getPermissions('/api/abp/application-configuration')
                        .then(resUser => {
                            userApi
                                .getUserInfo(resUser.currentUser.id)
                                .then(result => {
                                    sessionStorage.setItem('userInfo', JSON.stringify(result.data));
                                    if (!localStorage.getItem('examList')) {
                                        localStorage.setItem('examList', []);
                                    }
                                    this.$router.push('/home');
                                    //window.location.href = this.webUrl;
                                    //this.$router.replace({ path: '/home' });
                                })
                                .catch(err => {
                                    console.warn(err);
                                });
                        })
                        .catch(err => {
                            console.warn(err);
                            this.closeLoading();
                        });
                    return;
                }
                //判断是否第三方跳转过来，Url登录对方系统传递scrept、ticks参数
                if (this.isUrlCallback()) {
                    const scrept = this.getScrept();
                    const ticks = this.getTick();
                    //获取scrept和ticks参数进行登录
                    this.getAuthInfo(scrept, ticks);

                } else {
                    //跳转到登录页
                    this.$router.push('/login');
                }
            },
            getScrept() {
                var reg = new RegExp('(^|&)Scrept=([^&]*)(&|$)', 'i')
                var r = window.location.search.substr(1).match(reg)
                if (r != null) return unescape(r[2])
                return null
            },
            getTick() {
                var reg = new RegExp('(^|&)Ticks=([^&]*)(&|$)', 'i')
                var r = window.location.search.substr(1).match(reg)
                if (r != null) return unescape(r[2])
                return null
            },
            getAuthInfo(scrept, ticks) {
                let params = {
                    scrept: scrept,
                    ticks: ticks,
                    webType: "Web"
                };

                //var webUrl = "";

                //userApi
                //    .getCopyright()
                //    .then(res => {
                //        res.data.forEach(item => {
                //            if (item.name == 'Abp.Identity.User.WebUrl') {
                //                this.webUrl = item.value;
                //            }
                //        });
                //    })
                //    .catch(err => {
                //        console.warn(err);
                //    });
                var webUrl = "";
                thirdLogin('/connect/singletoken-url', params)
                    .then(res => {
                        if (res.error) {
                            //this.$error(res.error_description);
                            this.token = res.error_description;
                            //手动登陆
                            this.$router.push('/login');
                        }
                        // this.token = res;
                        sessionStorage.setItem('token', res.access_token);
                        this.webUrl = res.access_url;
                        // this.token = '登录成功正在跳转';
                        console.warn('获取token成功');
                        getPermissions('/api/abp/application-configuration')
                            .then(resUser => {
                                userApi
                                    .getUserInfo(resUser.currentUser.id)
                                    .then(result => {
                                        sessionStorage.setItem('userInfo', JSON.stringify(result.data));
                                        if (!localStorage.getItem('examList')) {
                                            localStorage.setItem('examList', []);
                                        }
                                        //this.$router.push('/home');
                                        //this.$router.replace({ path: '/home' });
                                        window.location.href = this.webUrl;
                                    })
                                    .catch(err => {
                                        console.warn(err);
                                    });
                            })
                            .catch(err => {
                                console.warn(err);
                                this.closeLoading();
                            });
                    })
                    .catch(err => {
                        console.warn(err);
                        this.token = err;

                    });
            },
            isUrlCallback() {
                const url = window.location.href
                var ser = (url.indexOf('Scrept=') != -1);
                var tick = (url.indexOf('Ticks=') != -1);
                if (ser && tick)
                    return true;
                else
                    return false;
            }

        }, created() {
            this.enableUrlAuth();

        }
    }
</script>
<style></style>